module.exports = __webpack_public_path__ + "img/loan-status1.ed2f0069.png";